import { showToast, showImagePreview, Image as VanImage } from 'vant';
import 'vant/es/image-preview/style';
export default {
  data() {
    return {
      viewhight: window.innerHeight - 50
    };
  },
  computed: {},
  components: {
    [showImagePreview.name]: showImagePreview,
    [VanImage.name]: VanImage
  },
  methods: {
    previewbu3() {
      showImagePreview({
        images: ['/img/bu3.jpg'],
        closeable: true,
        maxZoom: 10
      });
    },
    onSubmit() {
      showToast('点击结算');
    }
  }
};